import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWrite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWrite"><Path d="M21 3H3V5H21V3Z" fill="currentColor"/><Path d="M17.1351 6.58594L22.4142 11.865L12.2791 22.0002H7V16.7211L17.1351 6.58594Z" fill="currentColor"/><Path d="M3 7H11.5V9H3V7Z" fill="currentColor"/><Path d="M8.0022 11H3V13H8.0022V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWrite;
